var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4804 1.03748C10.0365 0.594834 9.43081 0.352952 8.80403 0.367969L2.39318 0.531369C1.17484 0.561761 0.194258 1.54216 0.163866 2.76069L0.000645038 9.17136C-0.0141932 9.79814 0.22751 10.4038 0.669976 10.8479L9.51967 19.6972C10.4139 20.5895 11.8614 20.5895 12.7557 19.6972L19.3297 13.1232C20.2234 12.2296 20.2234 10.7807 19.3297 9.88699L10.4804 1.03748ZM18.6826 12.476L12.1085 19.0499C11.572 19.5853 10.7033 19.5853 10.1668 19.0499L1.31732 10.2006C1.05184 9.93401 0.906673 9.57074 0.915612 9.1946L1.07883 2.78393C1.09725 2.05292 1.68541 1.46457 2.41642 1.44634L8.82709 1.28294C8.83871 1.28276 8.84998 1.28258 8.8616 1.28258C9.22576 1.28312 9.57491 1.42774 9.83288 1.68482L18.6826 10.5343C19.2178 11.0708 19.2178 11.9395 18.6826 12.476Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98238 4.14637C4.76546 4.14637 3.77899 5.13285 3.77881 6.34976C3.77881 7.56668 4.76546 8.55316 5.9822 8.55316C7.19912 8.55316 8.1856 7.56668 8.1856 6.34976C8.18417 5.13356 7.19858 4.1478 5.98238 4.14637ZM5.98238 7.63783C5.27086 7.63783 4.69431 7.06111 4.69413 6.34976C4.69413 5.63842 5.27086 5.06169 5.9822 5.06169C6.69355 5.06169 7.27027 5.63842 7.27027 6.34976C7.26956 7.06075 6.69337 7.63694 5.98238 7.63783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.255761ba5a85adfcbfa55b49604f81da.svg";
export { ForwardRef as ReactComponent };